import type { GlobalSearchResponse } from '../../extensions'

export const data = {
  nextPageMarker: 20,
  total: {
    value: 10000,
    relation: 'Gte',
  },
  items: [
    {
      application: 'contact',
      id: '90132',
      score: 1,
      data: {
        userKey: 'result1',
        firstName: 'Kermit',
        lastName: 'TheFrog',
        keywords: '456',
        phone: '123-456-7890',
        email: '',
      },
    },
    {
      application: 'contact',
      id: '91343',
      score: 1,
      data: {
        userKey: 'result2',
        firstName: 'Miss',
        lastName: 'Piggy',
        keywords: '456',
        phone: '123-456-7890',
        email: '',
      },
    },
    {
      application: 'contact',
      id: '94137',
      score: 1,
      data: {
        userKey: 'result3',
        firstName: 'Fozzie',
        lastName: 'Bear',
        keywords: '456',
        phone: '123-456-7890',
        email: 'really456incrediblyextremelylongemailaddress@superlongemailaddressdomainnamewebsite.com',
      },
    },
    {
      application: 'contact',
      id: '96771',
      score: 1,
      data: {
        userKey: '3838948547100956682',
        firstName: 'Elisa',
        lastName: 'Matteo',
        keywords: '@shell',
        phone: '555-Elisa',
        email: 'elisa@goto.com',
      },
    },
    {
      application: 'contact',
      id: '66381',
      score: 1,
      data: {
        userKey: '4547668473900510970',
        firstName: 'Vincent',
        lastName: 'Audy',
        keywords: '@shell',
        phone: '555-Vincent',
        email: 'vincent@goto.com',
      },
    },
    {
      application: 'contact',
      id: '37227',
      score: 1,
      data: {
        userKey: '158619268522209074',
        firstName: 'Elise',
        lastName: 'Pelchat',
        keywords: '@shell',
        phone: '555-Elise',
        email: 'elise@goto.com',
      },
    },
    {
      application: 'contact',
      id: '26433',
      score: 1,
      data: {
        userKey: '602681216181426860',
        firstName: 'Marie',
        lastName: 'Foxall',
        keywords: '@shell',
        phone: '555-Marie',
        email: 'marie@goto.com',
      },
    },
    {
      application: 'contact',
      id: '75936',
      score: 1,
      data: {
        userKey: '6146506820683186259',
        firstName: 'Brian',
        lastName: 'Motherway',
        keywords: '@shell',
        phone: '555-Brian',
        email: 'brian@goto.com',
      },
    },
    {
      application: 'contact',
      id: '26541',
      score: 1,
      data: {
        userKey: '6300506601969632429',
        firstName: 'Daniel',
        lastName: 'Bart',
        keywords: '@shell',
        phone: '555-Daniel',
        email: 'daniel@goto.com',
      },
    },
    {
      application: 'contact',
      id: '60757',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'Jose',
        lastName: 'Gomez',
        keywords: '@shell',
        phone: '555-Jose',
        email: 'jose@goto.com',
      },
    },
    {
      application: 'contact',
      id: '48485',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Entry',
        keywords: '@shell',
        phone: '555-Jose',
        email: 'jose@goto.com',
      },
    },
    {
      application: 'contact',
      id: '82933',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test',
        keywords: '@shell',
        phone: '555-Jose',
        email: 'jose@goto.com',
      },
    },
    {
      application: 'contact',
      id: '86369',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 1',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '90126',
      score: 1,
      data: {
        userKey: '3838948547100956682',
        firstName: 'New',
        lastName: 'Test 2',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '36809',
      score: 1,
      data: {
        userKey: '4547668473900510970',
        firstName: 'New',
        lastName: 'Test 3',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '81203',
      score: 1,
      data: {
        userKey: '158619268522209074',
        firstName: 'New',
        lastName: 'Test 4',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '38627',
      score: 1,
      data: {
        userKey: '602681216181426860',
        firstName: 'New',
        lastName: 'Test 5',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '26903',
      score: 1,
      data: {
        userKey: '6146506820683186259',
        firstName: 'New',
        lastName: 'Test 6',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '30005',
      score: 1,
      data: {
        userKey: '6300506601969632429',
        firstName: 'New',
        lastName: 'Test 7',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '75440',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 8',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '45425',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 9',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '98538',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 10',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '23959',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 1',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '56240',
      score: 1,
      data: {
        userKey: '3838948547100956682',
        firstName: 'New',
        lastName: 'Test 2',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '67588',
      score: 1,
      data: {
        userKey: '4547668473900510970',
        firstName: 'New',
        lastName: 'Test 3',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '19236',
      score: 1,
      data: {
        userKey: '158619268522209074',
        firstName: 'New',
        lastName: 'Test 4',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '80061',
      score: 1,
      data: {
        userKey: '602681216181426860',
        firstName: 'New',
        lastName: 'Test 5',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '94842',
      score: 1,
      data: {
        userKey: '6146506820683186259',
        firstName: 'New',
        lastName: 'Test 6',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '89269',
      score: 1,
      data: {
        userKey: '6300506601969632429',
        firstName: 'New',
        lastName: 'Test 7',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '30094',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 8',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '57706',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 9',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '14830',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 10',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '85716',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 1',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '76369',
      score: 1,
      data: {
        userKey: '3838948547100956682',
        firstName: 'New',
        lastName: 'Test 2',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '28488',
      score: 1,
      data: {
        userKey: '4547668473900510970',
        firstName: 'New',
        lastName: 'Test 3',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '52915',
      score: 1,
      data: {
        userKey: '158619268522209074',
        firstName: 'New',
        lastName: 'Test 4',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '60996',
      score: 1,
      data: {
        userKey: '602681216181426860',
        firstName: 'New',
        lastName: 'Test 5',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '97113',
      score: 1,
      data: {
        userKey: '6146506820683186259',
        firstName: 'New',
        lastName: 'Test 6',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '35139',
      score: 1,
      data: {
        userKey: '6300506601969632429',
        firstName: 'New',
        lastName: 'Test 7',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '88469',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 8',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '68402',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 9',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '95985',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 10',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '28346',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 1',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '96010',
      score: 1,
      data: {
        userKey: '3838948547100956682',
        firstName: 'New',
        lastName: 'Test 2',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '74486',
      score: 1,
      data: {
        userKey: '4547668473900510970',
        firstName: 'New',
        lastName: 'Test 3',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '36274',
      score: 1,
      data: {
        userKey: '158619268522209074',
        firstName: 'New',
        lastName: 'Test 4',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '36294',
      score: 1,
      data: {
        userKey: '602681216181426860',
        firstName: 'New',
        lastName: 'Test 5',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '72250',
      score: 1,
      data: {
        userKey: '6146506820683186259',
        firstName: 'New',
        lastName: 'Test 6',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '28609',
      score: 1,
      data: {
        userKey: '6300506601969632429',
        firstName: 'New',
        lastName: 'Test 7',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '20864',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 8',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '33995',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 9',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
    {
      application: 'contact',
      id: '61264',
      score: 1,
      data: {
        userKey: '7205586075161961226',
        firstName: 'New',
        lastName: 'Test 10',
        keywords: '@paging',
        phone: '555-test',
        email: 'test@goto.com',
      },
    },
  ],
} as GlobalSearchResponse

//Find out more on total object from cbox
export const apiData = {
  nextPageMarker: 20,
  total: {
    value: 10000,
    relation: 'Gte',
  },
  items: [
    {
      application: 'voicemail',
      id: '321767',
      score: 2,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 2,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 81071,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321773',
      score: 8,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 8,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 87372,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321761',
      score: 6,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 6,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 82805,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321770',
      score: 2,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 2,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 63074,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321803',
      score: 8,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 8,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 15962,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321776',
      score: 8,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 8,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 17930,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321781',
      score: 9,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 9,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 55359,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '155008',
      score: 6,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 6,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 47511,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '155009',
      score: 2,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 2,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 91078,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321762',
      score: 2,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 2,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 40875,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321765',
      score: 4,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 4,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 10464,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321808',
      score: 6,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 6,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 77170,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321810',
      score: 10,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 10,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 85071,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321771',
      score: 5,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 5,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 89527,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321778',
      score: 2,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 2,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 48766,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321802',
      score: 7,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 7,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 13106,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321764',
      score: 10,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 10,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 72345,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321768',
      score: 6,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 6,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 14443,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321756',
      score: 4,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 4,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 11509,
        transcript: 'hello world',
      },
    },
    {
      application: 'voicemail',
      id: '321759',
      score: 10,
      data: {
        callerid: 'Hackathon-Great-Scaling-UAC',
        context: 'outgoing',
        duration: 10,
        folder: 'INBOX',
        origdate: 'Wed Jul  8 04:20:26 PM UTC 2020',
        voicemail_id: 57966,
        transcript: 'hello world',
      },
    },
  ],
} as GlobalSearchResponse
